<template>
    <div>
        <svg viewBox="0 0 18 18" width="14" height="14">
            <path fill="currentColor" d="M13.5 1c-.3 0-.6.1-.8.3L6.4 7.6c-.3.3-.5.7-.6 1.1l-.6 2.5c-.1.5.3.9.8.8l2.5-.6c.4-.1.8-.3 1.1-.6l6.3-6.3c.5-.5.5-1.2 0-1.7l-1.6-1.6c-.2-.2-.5-.3-.8-.3zM4 12c-1.1 0-2 .9-2 2s-.5 1.6-1 2c.8.4 1.8.5 2.6.3 1.1-.3 2-1.2 2.3-2.3.2-1.1-.6-2-1.9-2z"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'paste-format',
}
</script>
